<template>
  <div class="gamPage">
    <div class="gamBox">
      <img src="@/assets/img/gam/machineT.png">
      <div class="gam">
        <img src="@/assets/img/gam/machine.png">
        <div class="round">
          <v-img contain :eager=true class="justify-center" :src="require('@/assets/img/gam/prize0.svg')" />
          <!-- <v-img contain :eager=true class="justify-center" 
          :src="require('@/assets/img/gam/prize'+prize+'.svg')" /> -->
        </div>
        <!-- <img v-if='this.round' src="@/assets/img/gam/round.png"> -->
        <img src="@/assets/img/gam/needle.png">
      </div>
      <img src="../assets/img/gam/machineB.png">
      <v-btn @click="getPrize(), $addTags(tags.getPrize,null,null,null)">
        <img src="../assets/img/gam/btnPlayNow.svg">
      </v-btn>
    </div>
    <!-- <v-btn @click="seePopUp('Thanks')">
      <img src="@/assets/img/gam/btnPlayNow.png">
    </v-btn> -->
    <popup :popupIconType="popupIconType" :popupItem="popupItem" :prize="prize" :inv_number="number" v-if="dialog"
      @popupStatus="dialog=false" />
  </div>
</template>

<script>
import axios from "axios";
  import swal from 'sweetalert2'
  import popup from '../components/popup'
  export default {
    name: 'gamPage',
    props: ['inv_number', 'inv_prize'],
    components: {
      popup,
    },
    data() {
      return {
        round: true,
        dialog: false,
        popupIconType: '',
        popupItem: '',
        number: "",
        className: '',
        prize: null,
        // game: '0',
        tags: {
          "getPrize": "D7029DA0D41D490DA5AC8E698ED680E2"

        }
      }
    },
    mounted() {
      // 從選單點選春風貓轉盤
      this.prize = this.$route.params.inv_prize
      this.number = this.$route.params.inv_number
      if (this.prize != null && this.prize != "銘謝惠顧") {
        this.seePopUp('Winning')
      }
      if (this.prize == "銘謝惠顧") {
        this.seePopUp('Thanks')
      }
    },
    methods: {
      // 顯示popup視窗
      seePopUp(val) {
        this.dialog = true
        this.popupIconType = 'icon' + val
        this.popupItem = val
      },
      // 獲得獎項
      getPrize() {
        var me = this;
        me.url = '/Liff/GetData_DrawPrize/8635309EEF564474B11CAEB66F3E5501'
        var config = {
          method: "post",
          headers: {
            Authorization: `Bearer ${me.$accessToken}`,
          },
          url: me.$apiUrl + me.url,
        }
        swal.fire({
          didOpen: () => {
            swal.fire({
              allowOutsideClick: false
            });
            swal.showLoading();
            axios(config).then(res => {
              var data = res.data;
              if (data && data.success) {
                this.prize = data.data.prize
                this.number = data.data.inv_number

                if (data.data.prize == '銘謝惠顧') {
                  this.className = 0
                  this.round = false

                  setTimeout(() => {
                    // 過3秒顯示銘謝惠顧
                    this.seePopUp('Thanks')
                    this.round = true
                  }, 3000);
                } else {
                  this.className = data.data.prize
                  this.round = false

                  setTimeout(() => {
                    // 過3秒顯示得獎資訊
                    this.seePopUp('Winning')
                    this.round = true
                  }, 3000);
                }
              }
            }).catch((err) => {
              console.log(err)
              alert("系統忙碌中，請稍後再試");
            }).finally(() => {
              swal.close();
            })
          }
        })
      },
    }
  }
</script>
<style lang="scss">
  .gamPage {
    width: 100%;
    height: calc(100vh - 56px);
    background-image: url(../assets/img/gam/gamBG.png);
    background-size: cover;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    img {
      width: 100%;
    }

    .gamBox {
      flex-direction: column;
      display: flex;
      justify-content: center;
      align-items: center;

      button {
        position: relative;
        top: -90px;
      }
    }

    .gam {
      position: relative;
      width: 100%;
      padding-top: 100%;

      .round {
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
      }

      >img {
        &:last-child {
          transform: rotate(180deg);
        }

        position: absolute;
        left: 0;
        top: 0;
      }
    }
  }
</style>